import Vue from 'vue';
import Router from 'vue-router';
import Login from './views/Login.vue';
import Notification from './views/Notification.vue';
import Home from './views/Home.vue';
import HMApi from '@/api/herningMobilitetApi';
import store from '@/store';
import Callback from './components/Callback.vue';

Vue.use(Router);

const router = new Router({
  mode: process.env.VUE_APP_ROUTER_HISTORY_MODE,
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/login',
      name: 'login',
      component: Login,
    },
    {
      path: '/notification/:id',
      name: 'notification',
      component: Notification,
    },
    {
      path: '/',
      name: 'home',
      component: Home,
    },
    {
      path: '/edit',
      name: 'create-trip',
      component: () =>
        import(/* webpackChunkName: "about" */ './views/TripEdit.vue'),
    },
    {
      path: '/edit/:id',
      name: 'edit-trip',
      component: () =>
        import(/* webpackChunkName: "about" */ './views/TripEdit.vue'),
    },
    {
      path: '/view/:id',
      name: 'view-trip',
      component: () =>
        import(/* webpackChunkName: "about" */ './views/TripView.vue'),
    },
    {
      path: '/callback',
      name: 'callback',
      component: Callback,
    },
  ],
});

router.beforeEach((to, from, next) => {
  if (to.path === '/callback') {
    return next();
  }
  if (to.name === 'notification') {
    return next();
  }
  if (
    to.name !== 'login' &&
    to.name !== 'view-trip' &&
    !localStorage.getItem('token')
  ) {
    // store.commit('setLoading', false);
    next('/login');
    // todo: returnUrl should work after login (now being errored by geodanmark login-page)
    // next(`/?returnUrl=${to.fullPath}`);
  } else if (to.name !== 'login' && to.name !== 'view-trip') {
    HMApi.getMe(localStorage.getItem('token'))
      .then(user => {
        store.commit('updateUser', user);
        if (user === null) {
          next('/login');
        }
        // store.commit('setLoading', false);
        next();
      })
      .catch(() => {
        store.commit('updateUser', null);
        localStorage.removeItem('token');
        next('/login');
      });
  } else {
    next();
  }
  next();
});

export default router;
